import { NativeStackScreenProps } from '@react-navigation/native-stack';

export interface DownloadTransactionReportModalProps {
  onLayout: (event: any) => void;
}

export enum DownloadTransactionReportStackRoutes {
  DownloadAccountTransactionReport = 'download-account-transaction-report',
  DownloadCardAccountTransactionReport = 'download-cardaccount-transaction-report'
}

export type DownloadTransactionReportStackParamList = {
  [DownloadTransactionReportStackRoutes.DownloadAccountTransactionReport]: DownloadTransactionReportModalProps & {
    walletId?: string;
  };
  [DownloadTransactionReportStackRoutes.DownloadCardAccountTransactionReport]: DownloadTransactionReportModalProps & {
    creditLineId?: string;
  };
};

export type DownloadTransactionReportStackScreenProps<Screen extends keyof DownloadTransactionReportStackParamList> =
  NativeStackScreenProps<DownloadTransactionReportStackParamList, Screen>;
